<template>
  <div class="add-post">
    <uploaderVideo ref="uploadDiv" :uploadType="4" @uploadSucc="handleUploadSucc"></uploaderVideo>
    <div class="upload-title">
      <input type="text" maxlength="50" v-model="subjectName" placeholder="填写标题,会有更多点赞哦~" class="input-title" />
    </div>
    <!-- maxlength="50" -->
    <!-- <van-field v-model="content" rows="6" autosize type="textarea" class="textarea" placeholder="请输入内容"
      show-word-limit /> -->
    <quill-editor v-model="content" :options="editorOption"></quill-editor>

    <div class="div-flex">
      <div class="flex-label">待办任务类型</div>
      <van-radio-group v-model="changeRadio" direction="horizontal" @change="handleChange">
        <van-radio icon-size="14px" checked-color="#EB1700" name="1">收集作业</van-radio>
        <van-radio icon-size="14px" checked-color="#EB1700" name="2">关联内容</van-radio>
      </van-radio-group>
    </div>
    <div class="radio1" v-if="changeRadio === '1'">
      <van-field v-if="`${roles.peSign}` === '1'" readonly clickable name="picker" class="field-color about-teacher"
        :value="teacherValue" label="关联导师" placeholder="点击选择关联导师" @click="showPicker = true" />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar title="选择关联导师" :columns="columnsUsers" @confirm="onConfirm"
          @cancel="showPicker = false" />
      </van-popup>
      <van-field readonly clickable name="picker" class="field-color cut-time" :value="cutTime" label="作业提交截至时间"
        placeholder="点击选择作业提交截至时间" @click="showPickerDate = true" />
      <van-popup v-model="showPickerDate" position="bottom">
        <van-datetime-picker v-model="currentDate" type="datetime" title="选择完整时间" :min-date="minDate"
          :max-date="maxDate" @confirm="onDateConfirm" @cancel="showPickerDate = false" />
      </van-popup>
    </div>
    <div class="radio2" v-if="changeRadio === '2'" @click="handleGo">
      <div class="label-txt">添加关联内容</div>
      <div class="con-txt">
        <div class="txt-div" v-for="(item, index) in changeAboutCon" :key="index">
          <span class="txt">{{ item && item.title }}</span>
          <img src="../../assets/images/zone/train_cnacel.png" class="icon-txt" alt="" @click.stop="handleClickDel(item)" />
        </div>
      </div>
    </div>
    <div class="fixed-btn" :class="{cur: allInput, upload: uploadPost }" @click="handleAddPost">
      发布
    </div>
  </div>
</template>
<script>
import {
  addPost,
  // roleDetails,
  selectAreaUsers,
  postDetails,
  updatePost
} from '@/api/zone'
import uploaderVideo from './compontents/uploaderVideo.vue'
import { toolbarOptions, roleIsConsumer, rolesClick } from './data'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    uploaderVideo,
    quillEditor
  },
  data () {
    return {
      fileList: [],
      maxCount: 9,
      content: '',
      subjectName: '',
      form: {},
      areaId: '', // 专区Id
      fileIds: [],
      changeRadio: '1',
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2027, 10, 1),
      currentDate: new Date(),
      roles: {},
      showPicker: false,
      showPickerDate: false,
      teacherValue: '',
      cutTime: '',
      columnsUsers: [], // 导师列表
      users: [],
      changeAboutCon: [],
      editorOption: {
        modules: {
          toolbar: toolbarOptions
        },
        theme: 'snow',
        placeholder: '请输入内容...'
      },
      uploadPost: false,
      contentMaxLength: 1000,
      tutorId: ''
    }
  },
  computed: {
    allInput () {
      return this.subjectName.length > 0 && this.content.length > 0
    },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  async mounted () {
    let role = JSON.parse(sessionStorage.getItem('roleResult'))
    if (roleIsConsumer(role, this.userInfo) || rolesClick(role, this.userInfo)) {
      this.$router.push({
        path: `/zoneDetails?areaId=${this.$route.query.areaId}`
      })
      return
    }
    this.areaId = this.$route.query.areaId
    this.changeRadio = this.$route.query.changeRadio
      ? this.$route.query.changeRadio
      : '1'
    this.dccId = this.$route.query.dccId
    let changeAboutCon = JSON.parse(localStorage.getItem('changeAboutCon'))
    if (changeAboutCon) {
      console.log(changeAboutCon)
      this.changeAboutCon = [
        ...changeAboutCon.case,
        ...changeAboutCon.course,
        ...changeAboutCon.docc
      ]
    }

    if (localStorage.getItem('addWorkCon')) {
      let storageWorkCon = JSON.parse(localStorage.getItem('addWorkCon'))
      this.fileList = storageWorkCon.fileList
      this.subjectName = storageWorkCon.subjectName
      this.content = storageWorkCon.content
      this.fileIds = storageWorkCon.fileIds
      this.cutTime = storageWorkCon.cutTime
      this.teacherValue = storageWorkCon.teacherValue
      if (storageWorkCon.videoObj && Object.keys(storageWorkCon.videoObj).length > 0) {
        this.$refs.uploadDiv.videoObj = storageWorkCon.videoObj
        this.$refs.uploadDiv.fileList = []
        this.$refs.uploadDiv.isUpload = true
      } else {
        this.$refs.uploadDiv.fileList = this.fileList
      }
      this.$refs.uploadDiv.uploadList = this.fileList
      this.$refs.uploadDiv.fileIds = this.fileIds
    }

    if (this.dccId && !this.$route.query.changeRadio) {
      const res = await postDetails({ postbarId: this.dccId })
      this.areaId = res.data.areaId
      this.subjectName = res.data.subjectName
      this.content = res.data.content
      this.adminFileMainId = this.dccId
      this.$refs.uploadDiv.handleFun(this.adminFileMainId)
      this.changeRadio = res.data.cutTime ? '1' : res.data.areaPostbarWorkDataDTOS.length ? '2' : '1'
      res.data.areaPostbarWorkDataDTOS.forEach(item => {
        item.isCheck = true
      })
      this.tutorId = res.data.tutorId
      // this.teacherValue = res.data.tutorName ? res.data.tutorName : ''
      this.changeAboutCon = res.data.areaPostbarWorkDataDTOS
      this.cutTime = res.data.cutTime ? this.$moment(
        new Date(Number(res.data.cutTime)).getTime()
      ).format('YYYY-MM-DD HH:mm:ss') : ''
      const dtos = {
        case: res.data.areaPostbarWorkDataDTOS.filter(item => item.type === 3),
        course: res.data.areaPostbarWorkDataDTOS.filter(
          item => item.type === 2
        ),
        docc: res.data.areaPostbarWorkDataDTOS.filter(item => item.type === 1)
      }
      localStorage.setItem('changeAboutCon', JSON.stringify(dtos))
      // this.handleFun()
    }

    this.roles = JSON.parse(sessionStorage.getItem('roleResult'))
    this.handleFun()
    // roleDetails({
    //   areaId: this.areaId,
    //   userId: this.userInfo.id
    // }).then(res => {
    //   this.roles = res.data
    //   this.handleFun()
    // })
  },
  methods: {
    handleFun () {
      let params = {
        areaId: this.areaId,
      }
      selectAreaUsers(params).then(res => {
        this.users = res.data.map(item => item.tutorInfo)
        this.columnsUsers = res.data.map(item => item.tutorInfo.realName)
        if (this.tutorId) {
          this.users.map(item => {
            if (item.id === this.tutorId) {
              this.teacherValue = item.realName
            }
          })
        }
      })
    },
    handleClickDel (item) {
      this.changeAboutCon = this.changeAboutCon.filter(
        res => res.id !== item.id
      )
      let changeAboutCon = JSON.parse(localStorage.getItem('changeAboutCon'))
      changeAboutCon.case = changeAboutCon.case.filter(
        res => res.id !== item.id
      )
      changeAboutCon.course = changeAboutCon.course.filter(
        res => res.id !== item.id
      )
      changeAboutCon.docc = changeAboutCon.docc.filter(
        res => res.id !== item.id
      )
      localStorage.setItem('changeAboutCon', JSON.stringify(changeAboutCon))
    },
    getPlainTextLen(richText) {
      return richText
        .replace(/<[^>]+>/g, '')
        .replace(/ |\n|\r\n|&nbsp;|&ensp;/g, '')
        .replace(/[a-zA-Z]&#7([6-7][0-9]);/g, ' ')
        .replace(/&([a-z]{2,5}|#[0-9]{1,6});/g, ' ')
        .length
    },
    handleAddPost () {
      if (!this.allInput) {
        this.$toast('请输入内容')
        return
      }
      if (this.getPlainTextLen(this.content) > this.contentMaxLength) {
        this.$toast('字数超过1000！')
        return
      }
      if (this.uploadPost) return
      this.uploadPost = true
      let params = {
        id: this.dccId,
        areaId: this.areaId,
        // 1发帖2投票3直播预估4代办任务(作业)
        type: '4',
        userId: this.userInfo.id,
        subjectName: this.subjectName,
        content: this.content,
        fileIds: this.fileIds,
        // kind: 类别1RTC2病例交流3心电图交流)
        kind: '1'
      }
      if (this.changeRadio === '1') {
        params.isWork = '1'
        if (`${this.roles.tutorSign}` === '1') {
          params.tutorId = this.userInfo.id
        } else if (this.teacherValue && this.changeRadio === '1') {
          params.tutorId = this.users.filter(
            res => res.realName === this.teacherValue
          )[0].id
        }
        // if (!this.cutTime) {
        //   this.$toast('请选择截止时间！')
        //   return
        // }
        if (this.cutTime) {
          params.cutTime = this.cutTime
        }
        params.workDataAddROS = []
      } else if (this.changeRadio === '2') {
        if (this.changeAboutCon.length > 0) {
          let aboutArr = this.changeAboutCon.map(res => {
            let items = {
              userId: this.userInfo.id,
              title: res.title,
              type: res.type,
              baseId: res.baseId,
              cover: res.coverUrl || res.cover,
            }
            return items
          })
          params.workDataAddROS = aboutArr
          params.cutTime = ''
        } else {
          this.$toast('请先选择关联内容')
          return
        }
      }
      if (params.id) {
        // const fileList = this.fileList.filter(item => item.id).map(item => item.id)
        // params.fileIds = fileList.concat(params.fileIds)
        delete params.kind
        updatePost(params).then(res => {
          this.$toast('发布成功')
          localStorage.removeItem('addWorkCon')
          localStorage.removeItem('changeAboutCon')
          setTimeout(() => {
            this.$router.push({
              path: `/dcc`
            })
          }, 1500)
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      } else {
        delete params.id
        addPost(params).then(res => {
          this.$toast('发布成功')
          localStorage.removeItem('addWorkCon')
          localStorage.removeItem('changeAboutCon')
          setTimeout(() => {
            this.$router.push({
              path: `/zoneDetails?areaId=${this.areaId}`
            })
          }, 1500)
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      }
    },
    onConfirm (value) {
      this.teacherValue = value
      this.showPicker = false
    },
    onDateConfirm (value) {
      this.cutTime = this.$moment(new Date(value).getTime()).format(
        'YYYY-MM-DD HH:mm:ss'
      )
      this.showPickerDate = false
    },
    handleGo () {
      let storageCon = {
        fileList: this.fileList,
        subjectName: this.subjectName,
        content: this.content,
        fileIds: this.fileIds,
        cutTime: this.cutTime,
        teacherValue: this.teacherValue,
        videoObj: this.videoObj
      }
      localStorage.setItem('addWorkCon', JSON.stringify(storageCon))
      this.$router.push({
        path: `/aboutContent?areaId=${this.areaId}&dccId=${this.dccId || ''}`
      })
    },
    handleUploadSucc (succon) {
      this.fileList = succon.uploadList
      this.fileIds = succon.uploadList.map(item => item.id)
      this.videoObj = succon.videoObj
    },
    handleChange(value) {
      if (value === '1') {
        this.cutTime = ''
      }
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.add-post {
padding-bottom: 90px;
box-sizing: border-box;
  .upload-imgs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 16px 14px;
    box-sizing: border-box;

    /deep/ .van-uploader__wrapper {
      .van-uploader__preview,
      .van-image,
      .van-uploader__upload {
        width: 109px;
        height: 109px;
        margin-right: 10px;

        &:nth-child(3n) {
          margin-right: 0;
        }
      }

      .van-uploader__upload-icon {
        font-size: 36px;
      }
    }
  }

  .upload-title {
    width: 100%;
    border-top: 1px solid #e8e8e8;
    box-sizing: border-box;
    padding: 0 14px;
    box-sizing: border-box;

    .input-title {
      line-height: 55px;
      height: 55px;
      border: none;
      border-bottom: 1px solid #e8e8e8;
      font-weight: 600;
      outline: none;
      background-color: transparent;
      width: 100%;
      font-size: 18px;
      color: #282828;

      &::placeholder {
        color: #c0c0c2;
      }
    }
  }

  .about-teacher {
    &::before {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      top: 0;
      left: 0;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }

  /deep/ .van-field__label {
    width: 120px;
    box-sizing: border-box;
  }

  /deep/ .van-field__control {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    text-align: right;

    &::placeholder {
      color: #c0c0c2;
    }
  }

  .textarea {
    /deep/ .van-field__control {
      text-align: left;
    }
  }

  /deep/ .van-radio__label {
    font-size: 14px;
    color: #343434;
  }

  .div-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 42px;
    padding: 0 14px;
    box-sizing: border-box;
  }
  .flex-label, /deep/ .field-color-request .van-field__label, .label-txt{
    font-size: 14px;
    color: #343434;
    line-height: 20px;
    padding-left: 8px;
    box-sizing: border-box;
    position: relative;
    &::before {
      content: "*";
      font-size: 14px;
      color: #FF3C3C;
      width: 12px;
      line-height: 20px;
      position: absolute;
      top: 3px;
      left: 0;
      box-sizing: border-box;
    }
  }

  .fixed-btn {
    position: fixed;
    bottom: 24px;
    left: 14px;
    width: calc(100vw - 28px);
    height: 42px;
    border-radius: 100px;
    background-color: #e6e6e6;
    font-size: 16px;
    color: #aeaeae;
    text-align: center;
    line-height: 42px;
    font-weight: 500;

    &.upload {
      color: #fff;
      background-color: #C0C0C0;
    }

    &.cur {
      color: #fff;
      background-color: #EB1700;
    }
  }
}

.radio2 {
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  margin: 0 14px;
  box-sizing: border-box;
  position: relative;
  min-height: 24px;

  &::before {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    top: 0;
    left: 0;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  &::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .label-txt {
    font-size: 14px;
    color: #343434;
    line-height: 20px;
  }

  .con-txt {
    height: 200px;
    width: 200px;
    overflow-y: auto;
  }

  .txt-div {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }

    .txt {
      color: #EB1700;
      font-size: 14px;
      white-space: nowrap;
      width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .icon-txt {
      width: 16px;
      height: 16px;
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/addWork.vue